import React from "react";
import TopLeftUserName from "../components/TopLeftUserName";
import {
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonPage,
  IonRow,
} from "@ionic/react";
import { useHistory } from "react-router";
const PrivacyPolicy = () => {
  let history = useHistory();
  return (
    <IonPage placeholder={undefined}>
      <IonHeader className="ion-no-border" placeholder={undefined}>
        <TopLeftUserName headerText={"Privacy Policy"}></TopLeftUserName>
        <IonGrid className="container" placeholder={undefined}></IonGrid>
      </IonHeader>
      <IonContent placeholder={undefined} className="slide-in-right">
        <IonGrid className="container" placeholder={undefined}>
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="py-42 ph-16">
                <h6 className="generic-info-heading mb-24">Privacy Policy</h6>
                <p className="generic-info-desc ion-text-start mb-24">
                  VirtuSense Technologies, Inc. (“<b>we</b>”, “<b>us</b>”, “
                  <b>our</b>”) operates the{" "}
                  <a href="mailto:www.virtusense.ai">www.virtusense.ai</a>{" "}
                  website (the “Site”), software, products, equipment, one or
                  more mobile applications, (collectively, the “
                  <b>Application</b>”) and related service offerings
                  (collectively, the “Services”) that links to this Privacy
                  Policy. This Privacy Policy applies to the Services.
                </p>
                <p className="generic-info-desc ion-text-start mb-24">
                  This Privacy Policy describes the types of information that we
                  may collect, use, and share information you may provide when
                  you use the Services.
                </p>
                <p className="generic-info-desc ion-text-start mb-24">
                  This Privacy Policy does not alter the terms of any other
                  agreement that you may have with us. Your use of the Services
                  constitutes your acceptance of this Privacy Policy, and when
                  you visit our website, download, or install any software or
                  Application, use any equipment, or use any related service
                  offerings, you specifically agree to this Privacy Policy. IF
                  YOU DO NOT AGREE WITH OUR POLICIES AND PRACTICES, PLEASE DO
                  NOT DOWNLOAD, INSTALL, REGISTER WITH, ACCESS OR USE THE
                  SERVICES
                </p>
                <p className="generic-info-heading fz-18 ion-text-start mb-24 ml-20">
                  A. Terms Pertaining Specifically to the Application:
                </p>
                <p className="generic-info-desc ion-text-start mb-24">
                  The Application provides an interface between Individual Users
                  and Care Providers to coordinate on care of the Individual
                  User. If you are a patient of or recipient of treatment,
                  therapy, or other services a Care Provider, who has requested
                  that you access the Application, you are an “Individual User.”
                  If you are an employee or subcontractor of a healthcare
                  provider, housing provider, rehab or therapy center or skilled
                  nursing facility that uses our Services, including the
                  Application, then you are a “Care Provider.
                </p>
                <p className="generic-info-heading fz-18 ion-text-start mb-24 ml-20">
                  B. Terms Pertaining to All Services:
                </p>
                <div className="ml-30">
                  <p className="generic-info-heading fz-18 ion-text-start mb-24">
                    1. Personal Information We Collect (including Health
                    Information and Use Data).
                  </p>
                  <p className="generic-info-desc ion-text-start mb-24">
                    “Personal Information” is data that can be used to uniquely
                    identify or contact a single person. We do not collect,
                    store, or utilize data like facial identification, voice
                    identification and fingerprint identification as part of the
                    Personal Information.
                  </p>
                  <p className="generic-info-desc ion-text-start mb-24">
                    You may access our Site without providing personal
                    information to us. We collect your name, email address and
                    telephone number through the Site if you elect to use the
                    Site’s “Contact Us” feature or if you request a
                    demonstration or other services through the Site (such as
                    support and other calls, system updates or certain
                    training).
                  </p>
                  <p className="generic-info-desc ion-text-start mb-24">
                    When you register to use the Services, we collect names and
                    email address. We also collect your birthdate if you are an
                    Individual User of the Services. Such birthdate your Care
                    Provider provides to us. Before you can access the Services,
                    if you are an Individual User, your Care Provider provides
                    us with your email address to identify you as a recipient of
                    their services, and if you are a Care Provider, your
                    organization provides us with your email address to identify
                    you as an authorized user of the Services on their behalf.
                    We use the name, email address and birthdate information for
                    authentication purposes upon registration and subsequently
                    during the Services’s use.
                  </p>
                  <p className="generic-info-desc ion-text-start mb-24">
                    If you are an Individual User, during the use of the
                    Services, your Care Provider may make certain of your
                    health, treatment, and diagnostic information available in
                    for purposes of coordinating your care with you. The
                    Services may also generate certain information regarding
                    your progress based on information you elect to input into
                    it, or which maybe generated automatically by analyzing
                    information about the Individual User that such user or
                    his/her Care Provider inputs. All such information is
                    referred to as “Health Information” in this Privacy Policy.
                    Any Health Information that can personally identify you is
                    treated as personal information under this Privacy Policy.
                    We have access to Health Information while making the
                    Services available to Individual Users and the Care
                    Provider. All information that we collect through or in
                    connection with the Services
                  </p>
                  <p className="generic-info-desc ion-text-start mb-24">
                    To use one or more Services, users are required to have a
                    username and password, which they determine, and which we
                    use for authentication purposes and treat as personal
                    information.
                  </p>
                  <p className="generic-info-desc ion-text-start mb-24">
                    Whenever you interact with the Services, we, as well as our
                    service providers, may use assorted technologies that
                    automatically or passively collect data about how the
                    Services are being accessed and used. This data may include
                    browser type, unique number assigned to identify such
                    device, operating system, application version, click path
                    taken through the Services, your use of features or
                    functions within the Services, and other usage information
                    (“Use Data”). This information helps us manage, improve, and
                    customize the features and functionality of the Services and
                    may be able to be used to identify you like personal
                    information. If you are an Individual User, to the extent
                    relevant to coordination of your care, we provide the
                    information to your Care Provider about your use. For
                    example, your interactions with the Application whether and
                    how often you may be engaging in exercises that have been
                    recommended. We may share such Use Data about your use of
                    the Services with your Care Provider.
                  </p>

                  <p className="generic-info-heading fz-18 ion-text-start mb-24">
                    2. How We Use Information We Collect:
                  </p>
                  <p className="generic-info-desc ion-text-start mb-24">
                    We collect and use your personal information, including
                    Health Information and Use Data, to: (a) make the Services
                    available, (b) allow the Services to serve as an interface
                    and communication tool between a specific Care Provider and
                    their specific Individual User, (c) provide features and
                    functionality users have requested in the Services, (d)
                    communicate about the Services with users, and (e) support,
                    manage, troubleshoot, protect and improve the Services and
                    our related service offerings.
                  </p>
                  <p className="generic-info-heading fz-18 ion-text-start mb-24">
                    3. Information We Share with Others
                  </p>
                  <p className="generic-info-desc ion-text-start mb-24">
                    In connection with the Services, we share personal
                    information of a specific Individual User, including Health
                    Information and Use Data, with their specific Care Provider.
                    We also reserve the right to use Health Information and Use
                    Data for any purposes on a de-identified basis (where
                    Individual Users are not identified). In connection with the
                    Services more generally, we may disclose your personal
                    information to third parties to protect the security and
                    integrity of the Services, to correct technical problems and
                    malfunctions of the Services, to technically process your
                    information, to provide the Services or to take precautions
                    against liability. We also may provide your personal
                    information to service providers who provide services on our
                    behalf, such as our data centers. If you request services
                    via a mobile device, your request will be transmitted via
                    your mobile carrier’s network and your carrier may have
                    access to it. Consult your carrier’s privacy policy for
                    additional information. We reserve the right to transfer any
                    information we have about you in connection with a sale,
                    merger, consolidation, change in control, transfer of
                    assets, reorganization, or liquidation of our business. We
                    reserve the right to disclose any personal information as
                    needed if that information is requested by law enforcement
                    agencies or if we are required to do so by law, treaty,
                    regulation, subpoena, court order, or by a government
                    entity. We also may disclose your personal information to
                    third parties if we have reason to believe that disclosing
                    such information is necessary to conduct investigations of
                    possible breaches of law, to cooperate in any legal
                    investigation, or to identify, contact, or bring legal
                    action against someone who may be violating any agreement
                    with us.
                  </p>
                  <p className="generic-info-heading fz-18 ion-text-start mb-24">
                    4. Do-Not-Track Requests, Third-Party Tracking
                  </p>
                  <p className="generic-info-desc ion-text-start mb-24">
                    The Services provided are individualized for specific
                    Individual Users. We do not honor “do not track” requests
                    for the Services as that is incompatible with the purpose of
                    the Services to generate Use Data to assist with Individual
                    Users’ coordination of care. Nor do we presently honor “do
                    not track” requests for the Site. Third parties, other than
                    a Care Provider of an Individual User or our vendors
                    assisting with making the Application available do not have
                    authorization from us to track your use of the Services or
                    track what other activities you may have engaged in before
                    or after using the Services (for example, using a different
                    application or website). Third parties, other than our
                    vendors assisting with making the Site available do not have
                    authorization from us to track your use of the Site or track
                    what other activities you may have engaged in before or
                    after using the Site (for example, using a different
                    application or website), but we cannot control what unknown
                    third parties seek to track when you are online.
                  </p>
                  <p className="generic-info-heading fz-18 ion-text-start mb-24">
                    5. Security
                  </p>
                  <p className="generic-info-desc ion-text-start mb-24">
                    We use reasonable precautions, including technical,
                    administrative, and physical procedures, to protect personal
                    information accessible through the Services including Site,
                    Application or otherwise in our control from loss, misuse,
                    or alteration. Although guaranteed security does not exist,
                    we make commercially reasonable efforts to handle such
                    information consistent with this Privacy Policy and
                    applicable laws. Due to factors outside our control, we
                    cannot guarantee that communications between you and us
                    within the Services will be free from unauthorized access by
                    third parties.
                  </p>
                  <p className="generic-info-heading fz-18 ion-text-start mb-24">
                    6. Data Retention.
                  </p>
                  <p className="generic-info-desc ion-text-start mb-24">
                    We will retain your personal information for as long as is
                    necessary for the purposes for which it was collected. The
                    precise period will depend on the reason why it was
                    collected. Those periods are also based on the requirements
                    of applicable laws, applicable legal and regulatory
                    requirements and periods relating to the commencement of
                    legal actions. For example, typically, we will keep your
                    information for the period that you are a registered user of
                    the Services and until the Individual User’s Care Provider,
                    or a Care Provider for its own purposes as a user of the
                    Services, communicates to us that the Individual User or
                    Care Provider, as applicable, no longer requires an account.
                    After accounts are no longer needed, we may retain
                    information from the account not intended to personally
                    identify users for the purpose of improving the Services and
                    our offerings.
                  </p>
                  <p className="generic-info-heading fz-18 ion-text-start mb-24">
                    7. Your Choices.
                  </p>
                  <p className="generic-info-desc ion-text-start mb-24">
                    If you need to correct, update, delete or deactivate your
                    personal information, please contact us by sending an email
                    to Info@virtusensetech.com. Please note that we may not be
                    able to correct or update your personal information
                    previously provided to us by your Care Provider and you may
                    need to notify them to make a change. You can also choose to
                    delete your account.
                  </p>
                  <p className="generic-info-heading fz-18 ion-text-start mb-24">
                    8. Push Notifications.
                  </p>
                  <p className="generic-info-desc ion-text-start mb-24">
                    If you do not want to receive push notifications from us,
                    you may simply unsubscribe from the Services.
                  </p>
                  <p className="generic-info-heading fz-18 ion-text-start mb-24">
                    9. Third-Party Links.
                  </p>
                  <p className="generic-info-desc ion-text-start mb-24">
                    The Services may contain links to third-party applications,
                    software and websites that are not controlled by us. Any
                    such links are made available to you as a convenience, and
                    you agree to use these links at your own risk. Please be
                    aware that we are not responsible for the privacy practices,
                    security, or content of such third-party services. Our
                    Privacy Policy only applies to information we collect from
                    you while you are using the Services. If you use a
                    third-party link from the Services, we strongly encourage
                    you to review and become familiar with that third-party
                    service’s own privacy policy and statements.
                  </p>
                  <p className="generic-info-heading fz-18 ion-text-start mb-24">
                    10. Children
                  </p>
                  <p className="generic-info-desc ion-text-start mb-24">
                    The Services are not intended for use by children, and we do
                    not knowingly collect personal information from children
                    under 13. If we learn that we have collected the personal
                    information of any such individual, we will take steps to
                    delete the information as soon as possible.
                  </p>
                  <p className="generic-info-heading fz-18 ion-text-start mb-24">
                    11. Notice to Residents of Countries Outside the United
                    States.
                  </p>
                  <p className="generic-info-desc ion-text-start mb-24">
                    We are headquartered in the United States and our Services
                    are currently only intended for individuals located in the
                    United States. If you are located outside of the United
                    States, be advised that any information you provide to us
                    will be transferred to and stored in the United States and
                    that, by submitting information to us, you explicitly
                    authorize its transfer and storage within the United States.
                    We will protect the privacy and security of personal
                    information according to this Privacy Policy regardless of
                    where it is processed or stored.
                  </p>
                  <p className="generic-info-heading fz-18 ion-text-start mb-24">
                    12. Your California Privacy Rights
                  </p>
                  <p className="generic-info-desc ion-text-start mb-24">
                    Pursuant to Section 1798.83 of the California Civil Code,
                    residents of California have the right to request from a
                    business with whom the California resident has an
                    established business relationship what types of personal
                    information, if any, the business shares with third parties
                    for direct marketing purposes by such third parties and the
                    identities of the third parties with whom the business has
                    shared such information in the immediately preceding
                    calendar year. We do not currently share any personal
                    information with third parties for direct marketing purposes
                    by such parties. If you have any questions, comments or
                    requested related to this Section, please contact us using
                    the information in Section 14 (“Contact Us”) below. A few
                    states are currently considering enacting laws like the
                    California law above. If you are a resident of a state that
                    enacts such a law, please use the contact information above
                    to contact us with any questions, requests, or comments.
                  </p>
                  <p className="generic-info-heading fz-18 ion-text-start mb-24">
                    13. Changes to Privacy Policy
                  </p>
                  <p className="generic-info-desc ion-text-start mb-24">
                    We reserve the right to change or replace this Privacy
                    Policy at our sole discretion at any time and we encourage
                    you to review this Privacy Policy periodically. If we make
                    material changes to this Privacy Policy, we will post the
                    updated Privacy Policy on this page. Any changes to the
                    Privacy Policy will become effective upon posting of the
                    revised policy. Your continued use of the Services following
                    the posting of changes constitutes your agreement to such
                    changes.
                  </p>
                  <p className="generic-info-heading fz-18 ion-text-start mb-24">
                    14. Contact Us
                  </p>
                  <p className="generic-info-desc ion-text-start mb-24">
                    If you have any questions about our Privacy Policy, please
                    feel free to contact us at 844-878-2255, or at
                    Info@virtusensetech.com.
                  </p>
                </div>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default PrivacyPolicy;
